import React from 'react';

import { useAppSelector } from '../../hooks';
import { TooltipTextContent } from './common';

export function RoofContainerTooltip(props: { guid: string }) {
  const roofContainer = useAppSelector((state) => state.layout.roofContainers[props.guid]);

  if (roofContainer == null) {
    console.warn('Unable to find roof container for tooltip.');
    return null;
  }

  return <TooltipTextContent text={`Roof Container ${roofContainer.name}`} />;
}
